import type {ReactElement} from 'react';
import {Text, TextSize} from '@Components/text';
import type {ChangeStylePopupProps} from './change-style-popup.types';

export function ChangeStylePopup({children}: ChangeStylePopupProps): ReactElement {
  return (
    <div className="flex-v-row gap-3">
      <Text val={window.i18next.t('pmwjs_ai_chat_change_style_heading')} size={TextSize.MD} bold />
      {children}
    </div>
  );
}
